import React, { createContext, ReactNode, useEffect, useMemo } from 'react';
import { useGetMemberBffData } from '../../api/member';
import useContext from '../../hooks/useContext';
import { goal, session } from '../../tracking/triggerbee';
import { useMemberNumber } from '../member';

interface ITriggerbeeContext {
  goal: (...args: any[]) => void;
  session: (goalId: string, session: ITriggerbeeSession) => void;
}

const TriggerbeeContext = createContext<ITriggerbeeContext | undefined>(undefined);

interface ITriggerbeeProvider {
  children: ReactNode;
}

const TriggerbeeProvider = ({ children }: ITriggerbeeProvider) => {
  const value = useMemo(
    () => ({
      goal,
      session,
    }),
    [goal, session],
  );

  return <TriggerbeeContext.Provider value={value}>{children}</TriggerbeeContext.Provider>;
};

const useTriggerbee = () => useContext(TriggerbeeContext);

const TriggerbeeMember = ({ children }: ITriggerbeeProvider) => {
  const memberNumber = useMemberNumber();
  const { session } = useTriggerbee();
  const member = useGetMemberBffData(!memberNumber)?.data?.member;

  useEffect(() => {
    if (memberNumber && member?.email) {
      session('login', { memberNumber, email: member?.email });
    }
  }, [memberNumber, member?.email]);

  return <>{children}</>;
};

export default ({ children }: ITriggerbeeProvider) => (
  <TriggerbeeProvider>
    <TriggerbeeMember>{children}</TriggerbeeMember>
  </TriggerbeeProvider>
);
